import axios from 'axios'

export const CMS_BASE_URL =
  import.meta.env.VITE_CMS_BASE_URL || 'https://cms.staging.digitrek.ae'

const cmsApiToken = import.meta.env.VITE_CMS_API_TOKEN?.trim()

export const cmsClient = axios.create({
  baseURL: CMS_BASE_URL,
  timeout: 15000,
  headers: cmsApiToken ? { Authorization: `Bearer ${cmsApiToken}` } : undefined,
})

export const CMS_MEDIA_BASE_URL = CMS_BASE_URL